import React, { useState } from 'react';
import { Event } from '../../types/event';
import EventCard from './EventCard';

interface EventListProps {
  events: Event[];
  loading: boolean;
  useSlug?: boolean;
}

const EventList: React.FC<EventListProps> = ({ events, loading, useSlug }) => {
  const [filter, setFilter] = useState<'all' | 'upcoming' | 'past'>('all');
  
  const filteredEvents = events.filter(event => {
    const eventDate = new Date(event.start_date);
    const today = new Date();
    
    if (filter === 'upcoming') {
      return eventDate >= today;
    } else if (filter === 'past') {
      return eventDate < today;
    }
    return true;
  });

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="text-center py-10">
        <p className="text-gray-500">Aucun événement disponible pour le moment.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-center mb-6">
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button
            type="button"
            onClick={() => setFilter('all')}
            className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
              filter === 'all'
                ? 'bg-primary text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            Tous
          </button>
          <button
            type="button"
            onClick={() => setFilter('upcoming')}
            className={`px-4 py-2 text-sm font-medium ${
              filter === 'upcoming'
                ? 'bg-primary text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            À venir
          </button>
          <button
            type="button"
            onClick={() => setFilter('past')}
            className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
              filter === 'past'
                ? 'bg-primary text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            Passés
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredEvents.map(event => (
          <EventCard key={useSlug ? event.slug : event.id} event={event} useSlug={useSlug} />
        ))}
      </div>

      {filteredEvents.length === 0 && (
        <div className="text-center py-10">
          <p className="text-gray-500">
            Aucun événement {filter === 'upcoming' ? 'à venir' : filter === 'past' ? 'passé' : ''} disponible.
          </p>
        </div>
      )}
    </div>
  );
};

export default EventList;
